import React, { useState, useEffect, useMemo } from 'react';
import debounce from 'lodash.debounce';
import { allContractTemplet, deleteContractTemplet } from "../../../ReduxStore/Slice/Templets/ContractTemplet";
import { useDispatch } from 'react-redux';
import Datatable from '../../../ExtraComponents/ReusableTable2';
import { useNavigate } from 'react-router-dom';
import { PenLine, Trash2 } from 'lucide-react';
import sweatalert from "sweetalert2";
import { Eye } from 'lucide-react';
import ReusableModal from '../../../ExtraComponents/ReusableModal';
import ReactPaginate from "react-paginate";


const ContractTemplets = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const token = localStorage.getItem("token");
  const [getAllContractTempletData, setAllContractTempletData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [showModal, setShowModal] = useState(false);


  const handleCloseModal = () => setShowModal(false);

  const [InputValue, setInputValue] = useState('');
  const [searchText, setSearchText] = useState('');
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);


  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  }

  // 1000ms debounce - actual search (InputValue) tabhi update hoga jab user typing rok de
  const debouncedSetInputValue = useMemo(
    () => debounce((value) => setInputValue(value), 1000),
    []
  );

  useEffect(() => {
    return () => debouncedSetInputValue.cancel();
  }, [debouncedSetInputValue]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);          // input turant update (UI responsive)
    debouncedSetInputValue(value); // API call 1000ms baad
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])




  useEffect(() => {
    getAllContractTemplet();;
  }, [currentPage, pageSize, InputValue]);



  const getAllContractTemplet = async () => {
    const req = { agent_id: agent_id, currentPage, limit: pageSize, search: InputValue };
    await dispatch(allContractTemplet(req)).unwrap()
      .then((response) => {
        if (response.status) {
          setAllContractTempletData(response.data);
          setTotalRecords(response?.pagination?.total)
        } else {
          setAllContractTempletData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };


  const deleteContractTempletRow = async (row) => {
    sweatalert.fire({
      title: "Are you sure?",
      text: "You want to delete this Contract Template! ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, agent_id: agent_id };
        await dispatch(deleteContractTemplet(req)).unwrap()
          .then((response) => {
            if (response.status) {
              sweatalert.fire({
                title: "Success",
                text: "Contract Template Deleted Successfully",
                icon: "success",
                timer: 3000,
                timerProgressBar: true
              }
              );
              getAllContractTemplet()
            }
          })
          .catch((error) => {
            console.error("Error deleting package:", error);
          });
      } else if (result.dismiss === sweatalert.DismissReason.cancel) {
        return
      }
    });

  }


  const handleEdit = (row) => {
    navigate(`/admin/template/edit-contract-template`, { state: row });
  }

  const columns = [
    {
      name: "Template Name",
      cell: (row) => (
        <a
          href={`#/admin/template/view-contract-template?id=${row.id}`}
          className="text-pink font-bold"
          style={{ fontWeight: "bold" }}
          onClick={(e) => {
            if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
              e.preventDefault();
              navigate("/admin/template/view-contract-template", {
                state: { row },
              });
            }
          }}
        >
          {row?.name}
        </a>
      ),
      selector: (row) => row?.name,
      sortable: true,
    },

    {
      name: "Subject",
      selector: (row) => row?.subject,
      sortable: true,
    },
    {
      name: 'Category',
      //selector: (row) => row?.ContractTemplateCategories?.[0]?.TemplateCategory?.name,
      selector: (row) => row?.enquirytype,
      sortable: true

    },
    {
      name: 'View Template',
      selector: (row) => <Eye onClick={() => { setShowModal(true); setSelectedRow(row) }} />,
      sortable: true
    },
    {
      name: "Show Header",
      selector: (row) => row?.header === 'all' ? "All Pages" : row?.header === 'single' ? "First Page only" : "None",
      sortable: true,
    },

    {
      name: "Show Footer",
      selector: (row) => row?.footer === 'all' ? "All Pages" : row?.footer === 'single' ? "First Page only" : "None",
      sortable: true,

    },

    {
      name: "Action",
      selector: (row) => <>
        <PenLine onClick={() => handleEdit(row)} />
        <Trash2
          onClick={() => deleteContractTempletRow(row)}
        />
      </>,
      sortable: true,
    },
  ];

  const showPagination  = pageSize !== 0 && Math.ceil(totalRecords / pageSize)
  return (
    <div>

      <section className="section dashboard">
        <div className="row">
          <div className='row'>
            <h5 className='col-lg-10'>
              <span className="ay-name" id="Day_Name">
                Contract Templates
              </span>
            </h5>
            <div className='col-lg-2'>
              <button className="btn btn-pink rounded ms-2 float-lg-end" onClick={() => navigate('/admin/template/create-contract-template')}>
                Create New
              </button>
            </div>
          </div>
          <div>
            <div className="row mb-3">
              <data className='col-lg-3 datatable-search'>
                <input type="text"
                  className='search p-2 icon'
                  placeholder='Search here'
                  value={searchText}
                  onChange={handleSearchChange}

                />
              </data>

            </div>

            < div className='table-main-div'>
              <Datatable
                columns={columns}
                data={getAllContractTempletData}
                filter={false}
              />
              {getAllContractTempletData.length > 0 ? <div>
                {
                   showPagination > 1 && (
                    <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize) || 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
                   )
                }
                

                <div className="mt-0">

                  <select 
                  //  className="perpage-select" 
                  className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
                   value={pageSize} 
                   onChange={handlePageSizeChange}>
                    {/* <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option> */}
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>{"ALL"}</option>


                  </select>
                </div>
              </div> : ""}
            </div>
          </div>
        </div>
      </section>
      <ReusableModal
        show={showModal}
        onClose={handleCloseModal}
        modalsize={"xl"}
        title={"Template Preview"}
        body={
          <>
            <div
              className="modal-body preview-body"
              dangerouslySetInnerHTML={{ __html: selectedRow.body || "" }}
              readOnly
            />
          </>
        }
        footer={
          <>
            <button className='btn btn-outline-secondary' onClick={handleCloseModal}>Cancel</button>

          </>
        }
      />
    </div>
  );
};

export default ContractTemplets;
